export default "__VITE_ASSET__cfq4nhGp__"